import Auth from './auth';
import Sportsbook from './sportsbook';
import Betting from './betting';
import _ from 'lodash';

export default class SportifyClient {

    constructor(defaults = {}) {
        
        this.options = _.defaults(defaults || {}, {
            sportsbookURL: 'https://httpbin.org/',
            bettingURL: 'https://httpbin.org/',
        });

        this.auth = new Auth();
        this.sportsbook = new Sportsbook();
        this.betting = new Betting();
    }

    setAuth(auth) {
        this.auth = auth;        
    }

}